import BidState from './BidState';

export default BidState;



// WEBPACK FOOTER //
// ./src/store/selectors/BidState/index.js